import Card from '@/components/Card'
import { formatDate } from '@/utils/formatters'
import {
  CheckCircle2,
  Clock,
  LucideIcon,
  ShieldCheck,
  XIcon,
} from 'lucide-react'
import * as React from 'react'
import { useForcedViewTheme } from '../theme'
import { cn } from '@/utils/style'
import {
  DegreeViewDegreeFragment,
  DocumentDegreeStatus,
  PublicViewFieldsFragment,
} from '@/graphql/generated/graphql'

type SummaryProps = {
  publicViewFields: PublicViewFieldsFragment
}

export default function Summary(props: SummaryProps) {
  const theme = useForcedViewTheme()
  const { Icon, color, label } = (() => {
    if (props.publicViewFields.isValid) {
      return {
        Icon: CheckCircle2,
        color: 'text-green-600',
        label: 'Documento válido',
      }
    }
    return { Icon: XIcon, color: 'text-red-600', label: 'Documento revogado' }
  })()

  return (
    <div className="h-auto max-w-6xl mt-4 mx-auto px-4 lg:px-0">
      <Card className="p-4 flex flex-col gap-4">
        <div className="flex gap-2 items-center">
          <p className="font-semibold text-lg">{label}</p>
          <Icon className={cn('w-6 h-6', color)} />
        </div>

        <div className="flex gap-4">
          <div className="text-md flex flex-col gap-2">
            <p
              style={{ color: theme.publicViewPrimaryColor }}
              className="text-sm font-medium"
            >
              Código de segurança
            </p>
            <div className="flex gap-2 items-center font-semibold">
              <ShieldCheck className="w-6 h-6 " />
              <p className="break-all	">{props.publicViewFields.securityCode}</p>
            </div>
          </div>
          <div className="text-md flex flex-col gap-2 border-l border-gray-200 pl-4">
            <p
              style={{ color: theme.publicViewPrimaryColor }}
              className="text-sm font-medium"
            >
              Data e hora da validação
            </p>
            <div className="flex gap-2 items-center font-semibold">
              <Clock className="w-6 h-6" />
              <p>{formatDate(props.publicViewFields.validationDatetime)}</p>
            </div>
          </div>
        </div>
      </Card>
    </div>
  )
}
